import React, { Component } from 'react';
import $ from 'jquery';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Row, Col } from 'react-bootstrap';

class Edit extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'UPDATE QUALIFICATION',
			isRedirect: false,
			showLoader: false,
			editData: this.props.editData,
		}

		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	handleFormSubmit(e) {
		e.preventDefault();
		this.setState({ showLoader: true, saveText: 'Updating..' });
		var formData = Sanitize.objectifyForm($("#frmAdd").serializeArray());
		Reqst.axPost('qualification/updatequalification', { token: Reqst.Token(formData) }).then(res => {
			if (res['data'].status == '1') {
				notify.show(res['data'].msg, 'success');
				this.setState({ showLoader: false, saveText: 'UPDATE QUALIFICATION' });
				if (this.props.afterFinish) this.props.afterFinish();
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false, saveText: 'UPDATE QUALIFICATION' });
			}
		});
	}

	getData(field) {
		var l = this.state.editData;
		return l[field];
	}

	setData(field, e) {
		var l = this.state.editData;
		l[field] = e.target.value;
		this.setState({ editData: l });
	}

	render() {

		return (
			<div>
				<form action="" method="post" encType="multipart/form-data" id="frmAdd" onSubmit={this.handleFormSubmit} >
					<input type="hidden" name="i__id" value={this.getData('id')} />
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<Row>
						<Col md={12} >
							<label>Type <span className="text-danger">*</span></label>
							<select name="i__type" id="i__type" className="form-control input-sm" required value={this.getData('coursetype')} onChange={this.setData.bind(this, 'coursetype')}>
								<option value="">Select Type</option>
								<option value="ug">UG</option>
								<option value="pg">PG</option>
							</select>
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>Course Category <span className="text-danger">*</span></label>
							<select name="i__cat" id="i__cat" className="form-control input-sm" required value={this.getData('coursecat')} onChange={this.setData.bind(this, 'coursecat')}>
								<option value="">Select</option>
								<option value="arts">Arts</option>
								<option value="science">Science</option>
								<option value="commerce">Commerce</option>
							</select>
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>Qualification <span className="text-danger">*</span></label>
							<input type="text" name="i__name" id="i__name" className="form-control input-sm" required value={this.getData('qualification')} onChange={this.setData.bind(this, 'qualification')} />
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>Active Status <span className="text-danger">*</span></label>
							<select name="i__status" id="i__status" className="form-control input-sm" required >
								<option value="1" selected={this.getData('qualificationstatus') == '1' ? 'selected' : ''} > Active </option>
								<option value="0" selected={this.getData('qualificationstatus') == '0' ? 'selected' : ''}  > In Active </option>
							</select>
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<br />
							<div className="text-right" >
								<button type="submit" className="btn btn-info btn-sm btn-success_2" disabled={this.state.saveText != 'UPDATE QUALIFICATION'} >
									<i className="fa fa-check"></i> {this.state.saveText}
								</button>
							</div>
						</Col>
					</Row>
				</form>
			</div>
		);
	}

}
export default Edit;